// src/app/auth/useAuth.ts
//
// The one hook components use for auth state and actions. Wraps
// authAdapter.ts — the sole source of truth for session state — with
// useSyncExternalStore, so components re-render on login/logout
// without any external state library. No @vanialabs/core-auth, no
// second copy of session logic: this file only calls the five
// functions authAdapter.ts exposes.
import { useSyncExternalStore } from 'react';
import { subscribe, getSession, isAuthenticated, login, logout } from './authAdapter';
import type { AuthSession, LoginResult } from './authAdapter';

export interface UseAuthResult {
  session: AuthSession | null;
  isAuthenticated: boolean;
  login: (mobile: string, password: string) => Promise<LoginResult>;
  logout: () => void;
}

export function useAuth(): UseAuthResult {
  const session = useSyncExternalStore(subscribe, getSession);
  const authenticated = useSyncExternalStore(subscribe, isAuthenticated);

  return {
    session,
    isAuthenticated: authenticated,
    login,
    logout,
  };
}
